export const ANALYTICS_CATALOG = {
  "test.create.dialogOpened": [],
  "test.create.dialogAbandoned": ["testType"],
  "test.create.stepReached": ["step", "entry"],
  "test.create.submitted": ["mode", "testType", "methodCode", "combinedParts", "labId"],
  "test.import.fileParsed": ["rowCount"],
  "test.import.validated": ["rowsValid", "rowsInvalid", "labId"],
  "test.import.submitted": ["rowsCreated", "rowsFailed", "labId"],
  "test.import.abandoned": ["rowCount"],
  "form.validation.blocked": ["surface", "sectionId", "field"],
  "test.acquisition.completeBlocked": ["errorCount"],
  "test.acquisition.completed": [],
  "test.save.conflict": ["reason"],
  "advisory.shown": ["tone", "advisoryId"],
  "toast.shown": ["level", "toastKey"],
  "units.switched": ["fromUnit", "toUnit", "quantity"],
  "form.section.toggled": ["sectionId", "expanded"],
  "nav.page.viewed": ["routePattern"],
  "list.filter.applied": ["filterKey", "cleared"],
  "list.search.performed": ["filterKey"],
  "list.results.empty": ["activeFilters"],
  "list.tab.switched": ["tab"],
  "list.pagination.changed": ["control"],
  "feature.used": ["feature", "detail"],
  "chart.node.removed": ["chart"],
  "modal.dismissed": ["modal", "outcome"],
  "api.request.slow": ["method", "requestPath", "durationMs"],
  "app.error": ["errorName", "statusCode", "requestPath", "method", "durationMs"],
  "app.crash": ["componentName"],
  "app.session.started": ["viewportClass", "online"],
} as const satisfies Record<string, readonly string[]>;

export type AnalyticsEventName = keyof typeof ANALYTICS_CATALOG;

export type CatalogProperties<E extends AnalyticsEventName> = Partial<
  Record<(typeof ANALYTICS_CATALOG)[E][number], string | number | boolean>
>;

export function assertAllowlisted<E extends AnalyticsEventName>(
  event: E,
  properties: CatalogProperties<E> | undefined,
): void {
  const allowed = new Set<string>(ANALYTICS_CATALOG[event]);
  const stray = Object.keys(properties ?? {}).filter((key) => !allowed.has(key));
  if (stray.length > 0) {
    throw new Error(`analytics: event "${event}" received non-allowlisted properties: ${stray.join(", ")}`);
  }
}
